export default "__VITE_ASSET__Dosjj0F8__"